export class Enterprise {
    id: number;
    enterprise_number?: any;
    enterprise_name: string;
    siren: string;
    legal_form: string;
    fix_phone: string;
    mob_phone?: any;
    entreprise_address: EntrepriseAddress;
    representative: Representative;
}

export class EntrepriseAddress {
    id: number;
    address_line_1: string;
    address_line_2?: any;
    city: string;
    post_code: string;
    state?: any;
    country_iso: string;
    created_at: Date;
    updated_at: Date;
    entreprise_id: number;
}

export class Representative {
    id: number;
    name: string;
    email: string;
    firstname: string;
    created_at: Date;
    updated_at: Date;
    entreprise_id: number;
    nationality_iso: string;
    birth_date: string;
}
